import { useTranslation } from 'react-i18next';
import { Modal, ModalProps } from '@rabbit/elements/shared-components';
import { useContext } from 'react';
import { AppContext } from '@rabbit/app-context';

interface ClaimInitiationWarningProps {
  onClose: () => void;
}

export function ClaimInitiationWarning({
  onClose,
}: ClaimInitiationWarningProps) {
  const { t } = useTranslation();
  const { tenantInfo } = useContext(AppContext);
  const { config } = useContext(AppContext);
  const tenantName = tenantInfo?.name || '';
  const tenantContactDetails = tenantInfo?.email || '';

  // Get the base message
  const baseMessage = t('claim.claimInitiationWarning', {
    tenantName,
    tenantContactDetails,
  });

  let formattedText = baseMessage;

  // Add additional text based on tenant for SUPAGARD
  if (
    config.CLAIMS.CONSUMER.SHOW_CLAIM_INITIATION_CONTACT &&
    tenantInfo?.claimsInfoPhone &&
    tenantInfo?.claimsInfoPhone.length > 0
  ) {
    formattedText =
      formattedText +
      '<br />' +
      t('claim.claimCallSupport', { phone: tenantInfo.claimsInfoPhone });
  }

  const modalSettings: ModalProps = {
    kind: 'pop-up',
    settings: {
      title: t('Claim Initiation'),
      text: formattedText,
      primaryButtonText: t('Okay'),
      handlePrimaryClick: onClose,
      handleClose: onClose,
    },
  };
  return <Modal {...modalSettings} />;
}

export default ClaimInitiationWarning;
